module.exports = __webpack_public_path__ + "static/media/21ECLAC35.9ba7e432.jpg";